import React from 'react';
import {
  Router,
  Route,
  Redirect } from 'react-router-dom';
import {
  PageHeader
} from 'react-bootstrap';

import App from './App';
import Home from './components/Home/Home';
import Profile from './components/Profile/Profile';
import Callback from './components/Callback/Callback';
import Auth from './utils/Auth';
import history from './history';

import logo from './logo.png';

const auth = new Auth();

const handleAuthentication = ({location}) => {
  if (/access_token|id_token|error/.test(location.hash)) {
    auth.handleAuthentication();
  }
}

export const makeMainRoutes = () => {
  return (
      <Router history={history}>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <PageHeader style={{backgroundColor:  "#cfd8dc", width: "100vw", textAlign: 'center', margin: 0}}>
            <img src={logo} className="logo" alt="logo" />
          </PageHeader>
          <Route path="/" render={(props) => <App auth={auth} {...props} />} />
          <Route path="/home" render={(props) => <Home auth={auth} {...props} />} />
          <Route path="/profile" render={(props) => (
            !auth.isAuthenticated() ? (
              <Redirect to="/home" />
            ) : (
              <Profile auth={auth} {...props} />
            )
          )} />
          <Route path="/callback" render={(props) => {
            console.log(props);
            handleAuthentication(props);
            return <Callback {...props} />
          }}/>
        </div>
      </Router>
  );
}


// WEBPACK FOOTER //
// ./src/routes.js